


<mat-form-field class="full-width">
  <input matInput type="text"
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    [formControl]="selectControl">
  </mat-form-field>

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (openedChange)="openedChange($event)">
    @for (data of filteredData | async; track data) {
      <mat-option>
        <div (click)="optionClicked($event, data)">
          <mat-checkbox [checked]="data.selected"
            (change)="toggleSelection(data)"
            (click)="$event.stopPropagation()">
            {{ data.itemDescription }}
          </mat-checkbox>
        </div>
      </mat-option>
    }
  </mat-autocomplete>

  <div class="chip-list-wrapper">
    <mat-chip-listbox #chipList>
      @for (select of selectData; track select) {
        <mat-chip-option class="cardinal-colors" (click)="removeChip(select)">
          <label class="truncate-text">{{ select.itemDescription }}</label>
          <mat-icon title="Quitar filtro" class="mat-chip-remove">cancel</mat-icon>
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </div>